import { getVisitorCustomFieldTypeDisplayLabel } from '../../../../feature/components/CustomFieldsSection/fieldTypeDisplayLabel';
import type { CustomFieldDetailModel } from './types';

const CUSTOM_FIELD_STATUS_BASE_KEY = 'web.admin.visitorManagement.customField.status';

function normalizeSearchValue(value: string): string {
  return value.trim().toLowerCase();
}

export function filterCustomFieldDetailRowsBySearch(
  tableRows: readonly CustomFieldDetailModel[],
  searchValue: string,
  t: (key: string) => string
): CustomFieldDetailModel[] {
  const query = normalizeSearchValue(searchValue);
  const enabledFilter = t(`${CUSTOM_FIELD_STATUS_BASE_KEY}.enabled`).toLowerCase();
  const disabledFilter = t(`${CUSTOM_FIELD_STATUS_BASE_KEY}.disabled`).toLowerCase();

  if (!query) {
    return [...tableRows];
  }

  return tableRows.filter(row => {
    const statusText = row.isEnabled ? enabledFilter : disabledFilter;

    return (
      row.fieldName.toLowerCase().includes(query) ||
      getVisitorCustomFieldTypeDisplayLabel(row.fieldType, t).toLowerCase().includes(query) ||
      statusText.includes(query)
    );
  });
}
